import {
  fonts,
  fontSize,
  lockedPrimary,
  lockedSecondary
} from './fonts';
import {
  embedDialogOpen
} from './embed';
import {
  signInDialogOpen
} from './signin';
import {
  shadowsModalOpen,
  shadowsObj
} from './shadows';
import { RESET_STATE } from '../actions/reset';
import { combineReducers } from 'redux';

// equivalent to
// const appReducer = combineReducers({
//   teamMembers: teamMembers(state.teamMembers, action)
// });
const appReducer = combineReducers({
  fonts,
  fontSize,
  lockedPrimary,
  lockedSecondary,
  embedDialogOpen,
  signInDialogOpen,
  shadowsModalOpen,
  shadowsObj
})

const rootReducer = (state, action) => {
  if (action.type === RESET_STATE) {
    state = undefined
  }
  return appReducer(state, action)
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js